import React, { useState, useCallback } from 'react'
import { useLocation } from 'react-router-dom'

const STORAGE_KEY_AUTO_SUJI = 'auto_suji_mode_startup'
const STORAGE_KEY_LAST_MODE = 'last_editor_mode'

function getCurrentModeFromPath(pathname: string): string {
  if (pathname.startsWith('/suji')) return 'suji'
  if (pathname.startsWith('/crdt') || pathname.startsWith('/notes')) return 'crdt'
  return 'standard'
}

export const ModeStartupToggle: React.FC = () => {
  const location = useLocation()
  const [enabled, setEnabled] = useState(() => {
    return localStorage.getItem(STORAGE_KEY_AUTO_SUJI) === 'true'
  })

  const handleToggle = useCallback(() => {
    setEnabled((prev) => {
      const next = !prev
      localStorage.setItem(STORAGE_KEY_AUTO_SUJI, String(next))

      const currentMode = getCurrentModeFromPath(location.pathname)
      localStorage.setItem(STORAGE_KEY_LAST_MODE, currentMode)

      return next
    })
  }, [location.pathname])

  return (
    <div
      className="flex items-center gap-2 px-3 py-1 rounded-full bg-gray-100 dark:bg-gray-800 cursor-pointer select-none"
      onClick={handleToggle}
      title="开启：启动进入速记模式 | 关闭：启动打开上次编辑的笔记"
    >
      <span
        className={`text-xs transition-colors duration-200 ${
          enabled
            ? 'text-blue-600 dark:text-blue-400'
            : 'text-gray-500 dark:text-gray-400'
        }`}
      >
        速记启动
      </span>

      <div
        className={`relative w-8 h-4 rounded-full transition-colors duration-200 ${
          enabled ? 'bg-blue-500' : 'bg-gray-300 dark:bg-gray-600'
        }`}
      >
        <div
          className={`absolute top-0.5 w-3 h-3 rounded-full bg-white shadow transition-transform duration-200 ${
            enabled ? 'translate-x-4' : 'translate-x-0.5'
          }`}
        />
      </div>
    </div>
  )
}

export default ModeStartupToggle